import * as Yup from 'yup';
import { Locale } from '@synergy/models';
import { fields } from '@synergy/utils';

import { PaymentTermFormikValues } from './models/payment-term-formik-values';

const fieldNames = fields<PaymentTermFormikValues>();

export const paymentTermsModalValidationSchema = (locale: Locale) =>
    Yup.object().shape({
        [fieldNames.text]: Yup.object().shape({
            [locale]: Yup.string().required('app.error.required'),
        }),
        [fieldNames.days]: Yup.number().typeError('app.error.required').required('app.error.required'),
        [fieldNames.netDays]: Yup.number().typeError('app.error.required').required('app.error.required'),
        [fieldNames.discount]: Yup.number()
            .typeError('app.error.required')
            .min(0, 'app.error.minZero')
            .max(100, 'app.error.maxHundred')
            .required('app.error.required'),
    });
